module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('kanban', {
    attrs: {
      "cols": _vm.cols,
      "data": _vm.data
    },
    scopedSlots: _vm._u([{
      key: "list",
      fn: function(props) {
        return [_c('invoice-list', _vm._g({
          staticClass: "invoice-list",
          attrs: {
            "invoices": _vm.visibleItems[props.col.value],
            "actions": _vm.actions,
            "loading": _vm.invoicesRequest.loading
          }
        }, _vm.events)), _vm._v(" "), (_vm.items[props.col.value] && (_vm.items[props.col.value].length >= _vm.visibleItemCount)) ? _c('v-card', {
          attrs: {
            "flat": ""
          }
        }, [_c('v-card-actions', [_vm._v("\n        Showing " + _vm._s(_vm.visibleItemCount) + " of " + _vm._s(_vm.items[props.col.value].length) + "\n        "), _c('v-btn', {
          attrs: {
            "flat": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              _vm.visibleItemCount += _vm.pageSize
            }
          }
        }, [_vm._v("Load more")])], 1)], 1) : _vm._e()]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-452d2f78","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/layout/ProgressKanban.vue
// module id = 1409
// module chunks = 9